export const BASE_API_URL = window.BASE_API_URL;
